
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function addPrzerwaInfo(grupaId,uwagi,oprawa=false,refreshGantAll,setShowWindowInfoPrzerwa) {

// id = procesor id
// console.log(" dropDate: "+dropDate)
  
  axios
  .put(IP + "API_0014_dodaj_info_przerwy/" + sessionStorage.getItem("token"),{
        grupaId,
        uwagi: uwagi,
        oprawa: oprawa
      })
    .then((res) => {
refreshGantAll()
setShowWindowInfoPrzerwa(false)

    })


}


    // const res = await axios.put(
    //   IP + "API_0014_dodaj_info_przerwy/" + sessionStorage.getItem("token"),
    //   {
    //     ...grupaId,
    //     uwagi: uwagi,
    //   }
    // );

    // API_0014_dodaj_info_przerwy